import { ProfileBadge } from "@/components/ProfileBadge";
import { type AppUser } from "@/lib/types";

interface NoAccessPageProps {
  user: AppUser;
  onSignOut: () => void;
}

/** Shown when an authenticated DoctorUser has no matching practice in the voice-service DB — i.e. their Emmy
 *  `cognito:groups` either has no `facility:{UUID}:*` entries, or the facilities they can access haven't been
 *  wired up in hlas emmy yet. (PRD-010 Stage 2 §Phase 2.2 "NoAccess page".)
 *
 *  Sign-out is still reachable from the ProfileBadge in the top-right — it's the only navigation available.
 */
export const NoAccessPage = ({ user, onSignOut }: NoAccessPageProps) => {
  return (
    <div className="min-h-screen bg-gray-100">
      <header className="bg-[#1a2b6b] text-white shadow-md">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-6 py-2.5">
          <span className="text-xl tracking-tight text-white">
            <span className="font-bold">hlas</span>
            <span className="italic font-light">emmy</span>
          </span>
          <ProfileBadge user={user} onSignOut={onSignOut} />
        </div>
      </header>
      <main className="mx-auto max-w-2xl p-8">
        <div className="rounded-2xl border border-gray-200 bg-white p-8 shadow-sm">
          <h1 className="mb-3 text-2xl tracking-tight text-[#1a2b6b]">hlas emmy zatím není aktivní</h1>
          <p className="mb-3 text-base text-gray-700">
            Jste přihlášeni jako <strong>{user.email}</strong>, ale pro vaši ordinaci ještě není služba{" "}
            <span className="italic">hlas emmy</span> nastavena.
          </p>
          <p className="mb-6 text-base text-gray-700">
            Pokud si myslíte, že by přístup již být měl, obraťte se prosím na podporu Emmy — pomůžeme vám službu
            aktivovat.
          </p>
          <a
            href="mailto:podpora@sestraemmy.cz?subject=hlas%20emmy%20%E2%80%94%20%C5%BE%C3%A1dost%20o%20aktivaci"
            className="inline-block rounded-md bg-[#1a2b6b] px-4 py-2 text-sm text-white hover:opacity-80"
          >
            Kontaktovat podporu
          </a>
        </div>
      </main>
    </div>
  );
};
